export default {
      id: "data-delivery-usage",
      viewBox: "0 0 495.003 495.003",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#data-delivery",
      toString: function () {
        return this.url;
      }
    }